import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  isLoading = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  show() {
      setTimeout(() => this.isLoading.next(true), 0);
  }

  hide() {
      setTimeout(() => this.isLoading.next(false), 0);
  }
}
